import React, { Component } from 'react';

class loading extends Component {
    constructor() {
        super();
        this.state = {
        }
    }


    render() {
        return (
            <fieldset >
                <h3>Verificando datos</h3>
                <p className="text-muted">En estos momentos estamos preparando el registro.</p>
                <div style={{}}>
                    <div className="loader" id="loader-1"></div>
                    <p className="text-muted" style={{ textAlign: "center" }}>Cargando información</p>
                </div>
            </fieldset >
        );
    }
}
export default loading;


// WEBPACK FOOTER //
// ./src/views/register/loading.js